import { render, staticRenderFns } from "./AssetCategoriesList.vue?vue&type=template&id=21e3b9bb&"
import script from "./AssetCategoriesList.vue?vue&type=script&lang=js&"
export * from "./AssetCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports